module.exports = __webpack_public_path__ + "img/huilv.2794479a.png";